export default {
    path: '/page/ad',
    name: 'ad',
    component: () => import('@/layouts/BaseLayout'),
    redirect: '/ad',
    children: [
        {
            path: '/ad',
            name: 'ad',
            meta: { title: '首页' },
            component: () => import('@/views/ad/ad'),
        },]

}